<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">Filtrar por</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">

            <div v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">
              <div v-if="role === 'SuperAdministrador'">
                <AccessibleElSelect
                  v-model="form.distribuidor.value"
                  prop="distribuidor"
                  :options="distribuidoresForAccessibleSelect"
                  :withFormItem="true"
                  @select="handleSelectDistribuidor"
                  id-prefix="organismosprovinciasfilter"
                >
                  <template slot="label">{{$t('distributors.distributor')}}</template>
                </AccessibleElSelect>
              </div>

              <AccessibleElSelect
                v-model="form.empresa.value"
                prop="empresa"
                :options="clientesForAccessibleSelect"
                :withFormItem="true"
                @select="handleSelectCliente"
                id-prefix="organismosprovinciasfilter"
              >
                <template slot="label">{{$t('app.client')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('organismoprovincia.CodigoOrganismo')}}
                <el-form-item prop="CodigoOrganismo">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.CodigoOrganismo.value"
                    maxlength="250"
                  />
                </el-form-item>
              </label>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('organismoprovincia.NombreOrganismo')}}
                <el-form-item prop="NombreOrganismo">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.NombreOrganismo.value"
                    maxlength="500"
                  />
                </el-form-item>
              </label>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('organismoprovincia.CodigoProvincia')}}
                <el-form-item prop="CodigoProvincia">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.CodigoProvincia.value"
                    maxlength="250"
                  />
                </el-form-item>
              </label>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('organismoprovincia.NombreProvincia')}}
                <el-form-item prop="NombreProvincia">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.NombreProvincia.value"
                    maxlength="500"
                  />
                </el-form-item>
              </label>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.Organismo.value"
                prop="Organismo"
                :options="organismosForAccessibleSelect"
                :withFormItem="true"
                :isDisabled="isLoadingSelect"
                :remote="true"
                :remote-method="remoteOrganismos"
                popperClass="wrap-select-popover"
                @focus="onFocusOrganismo"
                id-prefix="organismosprovinciasfilter"
              >
                <template slot="label">{{$t('app.organismo_zc')}}</template>
              </AccessibleElSelect>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'
import { getDistributors } from '@/services/distributors/getDistributors'
import { getClients } from '@/services/clients/getClients'
import { getOrganismosAll } from '@/services/configurations/getOrganismosAll'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default {
  name: 'filter-panel',
  components: {
    AccessibleElSelect
  },
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    distribuidoresForAccessibleSelect: function () {
      return this.distribuidores.map(item => ({
        id: item.IdDistribuidor,
        name: item.Nombre,
        value: item.Nombre
      }))
    },
    clientesForAccessibleSelect: function () {
      return this.clientes.map(item => ({
        id: item.IdEmpresa,
        name: item.Nombre,
        value: item.Nombre
      }))
    },
    organismosForAccessibleSelect: function () {
      return this.valuesOrganismos.map(item => ({
        id: item.id,
        name: item.label,
        value: item.value
      }))
    }
  },
  data: function () {
    return {
      vuexnamespace: 'orgprovinces',
      isOpen: this.panelOpen,
      links: [],
      valuesOrganismos: [],
      loadingOrganismos: false,
      form: {
        CodigoOrganismo: { label: i18n.t('organismoprovincia.CodigoOrganismo'), value: '' },
        NombreOrganismo: { label: i18n.t('organismoprovincia.NombreOrganismo'), value: '' },
        CodigoProvincia: { label: i18n.t('organismoprovincia.CodigoProvincia'), value: '' },
        NombreProvincia: { label: i18n.t('organismoprovincia.NombreProvincia'), value: '' },

        Organismo: { label: i18n.t('app.organismo_zc'), value: '' },
        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        empresa: { label: i18n.t('app.client'), value: '' },
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      distribuidores: [],
      clientes: [],
    }
  },

  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  mounted: async function () {
    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
      }
      this.clientes = dataClients.Empresas

      if (this.role === 'SuperAdministrador') {
        const dataDistributors = await getDistributors()
        if (dataDistributors.blnError === true) {
          this.doFeedback(dataDistributors.msgError + ' [Código de error: ' + dataDistributors.codError + ']')
        }
        this.distribuidores = dataDistributors.Distribuidores
      }
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.CodigoOrganismo.value = _temp.CodigoOrganismo !== undefined && _temp.CodigoOrganismo.value !== '' ? _temp.CodigoOrganismo.value : ''
        this.form.NombreOrganismo.value = _temp.NombreOrganismo !== undefined && _temp.NombreOrganismo.value !== '' ? _temp.NombreOrganismo.value : ''
        this.form.CodigoProvincia.value = _temp.CodigoProvincia !== undefined && _temp.CodigoProvincia.value !== '' ? _temp.CodigoProvincia.value : ''
        this.form.NombreProvincia.value = _temp.NombreProvincia !== undefined && _temp.NombreProvincia.value !== '' ? _temp.NombreProvincia.value : ''

        this.form.Organismo.value = _temp.Organismo !== undefined && _temp.Organismo.value !== '' ? _temp.Organismo.value : ''

        this.form.empresa.value = _temp.empresa !== undefined && _temp.empresa.value !== '' ? _temp.empresa.value : ''
        this.form.distribuidor.value = _temp.distribuidor !== undefined && _temp.distribuidor.value !== '' ? _temp.distribuidor.value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        CodigoOrganismo: { label: i18n.t('organismoprovincia.CodigoOrganismo'), value: '' },
        NombreOrganismo: { label: i18n.t('organismoprovincia.NombreOrganismo'), value: '' },
        CodigoProvincia: { label: i18n.t('organismoprovincia.CodigoProvincia'), value: '' },
        NombreProvincia: { label: i18n.t('organismoprovincia.NombreProvincia'), value: '' },

        Organismo: { label: i18n.t('app.organismo_zc'), value: '' },
        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        empresa: { label: i18n.t('app.client'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    querySearch: function (queryString, cb) {
      const links = this.links
      const results = queryString ? links.filter(this.createFilter(queryString)) : links
      // call callback function to return suggestions
      cb(results)
    },
    createFilter: function (queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    handleSelectCliente: function (item) {
      this.form.empresa.value = item.id
    },
    handleSelectDistribuidor: function (item) {
      this.form.distribuidor.value = item.id
    },
    formatNombreOrg (element) {
      return element.Nombre + ' - ' + element.CIF
    },
    remoteOrganismos: async function (query) {
      this.valuesOrganismos = []
      if (query !== '' && this.loadingOrganismos === false && query.length > 2) {
        this.loadingOrganismos = true
        setTimeout(async () => {
          const organismos = await getOrganismosAll({ filtro: query })
          if (organismos.blnError === true) {
            this.doFeedback(organismos.msgError + ' [Código de error: ' + organismos.codError + ']')
          }
          if (organismos.DatosOrganismos !== undefined && organismos.DatosOrganismos?.length > 0) {
            let organismosMatch = []
            if (organismos.DatosOrganismos.length > 200) {
              organismosMatch = organismos.DatosOrganismos.filter(x => x.CIF.toUpperCase() === query.toUpperCase() || x.Nombre.toUpperCase() === query.toUpperCase())
              if (organismosMatch.length > 0) {
                this.doFeedback('Se han encontrado resultados coincidentes, pero se ha excedido el límite para los que contienen la búsqueda. Si el resultado esperado no aparece, introduzca más texto para acortar la búsqueda.', 'info', 5000)
              } else {
                this.doFeedback('Se ha excedido el límite de resultados en la búsqueda. Por favor, introduzca más texto para acortar la búsqueda.', 'info', 5000)
              }
            } else {
              organismosMatch = organismos.DatosOrganismos
            }
            organismosMatch.forEach(element => {
              this.valuesOrganismos.push(
                { 
                  id: element.idOrganismo, 
                  value: element.Nombre,
                  label: this.formatNombreOrg(element),
                }
              )
            })
          }
          this.loadingOrganismos = false
        }, 200)
      }
    }
  }
}
</script>
